import { useEffect, useState } from 'react'
import ResetUserPassword from '../../data_layer/repositories/Users/ResetUserPassword';

export const useResetPassword = (user_id) => {

    const [isLoading, setIsLoading] = useState(true);
    const [response, setResponse] = useState();

    useEffect(() => {
        if(user_id)
            resetUserPassword();
    }, [])
    
    const resetUserPassword = async () => {
        const resetResponse = await ResetUserPassword(user_id);
        setResponse(resetResponse);
        setIsLoading(false);
    }

    return {
        isLoading,
        response,
    }
}
